import { render } from "./AgencyCoreData.vue?vue&type=template&id=72a50945"
import script from "./AgencyCoreData.vue?vue&type=script&lang=js"
export * from "./AgencyCoreData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__